export default "__VITE_ASSET__Bp$vEqte__"